module.exports = __webpack_public_path__ + "assets/img/672736ccbecd4b4ef31d6e73db91c0b3.png";